import { Outlet } from 'react-router-dom';
import { Sidebar } from '@/components/shell/Sidebar';
import { TopBar } from '@/components/shell/TopBar';
import { Toaster } from '@/components/ui/sonner';

/**
 * Consumer app shell.
 *
 * Layout
 * - lg+: fixed left sidebar + top bar + main content
 * - <lg: top bar only; navigation moves to the hamburger drawer inside TopBar.
 *   We intentionally do NOT render a bottom tab bar on mobile (Phase 13 decision)
 *   — the left-slide drawer provides full access to every consumer route.
 *
 * Spacing
 * - Mobile uses `pb-[max(24px,env(safe-area-inset-bottom))]` to clear iOS home
 *   indicator without reserving room for a non-existent bottom nav.
 */
export const AppShell = () => {
  return (
    <div className="min-h-screen flex bg-[hsl(var(--background))]">
      <Sidebar />
      <div className="flex-1 min-w-0 flex flex-col">
        <TopBar />
        <main
          className="flex-1 px-4 sm:px-6 lg:px-8 py-5 sm:py-8 pb-[max(24px,env(safe-area-inset-bottom))]"
          data-testid="app-shell-main"
        >
          <Outlet />
        </main>
      </div>
      <Toaster position="top-right" richColors />
    </div>
  );
};
